'use strict';
var { tns } = require("tiny-slider");
const urlHelper = require('../utils/urlHelper');
const SELECTORS = {
    body: 'body',
    duplicateLookBtn: '.js-duplicate-look-btn',
    saveLookBtn: '.js-save-look-btn',
    imageThumnails: '.js-look-thumbnails',
    imageThumnailsModal: '.js-look-thumbnails-modal',
    customLookName: '.js-custom-look-name',
    customLookModalContent: '.js-custom-look-name-modal .modal-content',
    carousel: '.js-thumbnails-carousel',
    duplicateModalCarousel: '.js-look-thumbnails-modal .js-thumbnails-carousel'
}

const handleDuplicateBtnClick = (e) => {
    let $this = $(e.currentTarget);
    $(SELECTORS.saveLookBtn).data('look-id', $this.data('lookid'));
    let $imageThumbnails = $(`${SELECTORS.imageThumnails}.${$this.data('lookid')}`);
    let $carousel = $imageThumbnails.find(SELECTORS.carousel);
    if ($carousel.length > 0) {
        $imageThumbnails = $carousel.parent();
        $(SELECTORS.imageThumnailsModal).html($imageThumbnails.html());
        let tnsParams = {
            items: 1,
            loop: false,
            navAsThumbnails: "false",
            mouseDrag: "true",
            swipeAngle: false,
            speed: 400,
            container: $(SELECTORS.duplicateModalCarousel).get(0)
        }

        tns(tnsParams);
    } else {
        $(SELECTORS.imageThumnailsModal).html($imageThumbnails.html());
    }
}

const handleSaveLookBtnClick = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);
    let lookId = $this.data('look-id');
    let url = $this.data('href');
    let customLookName = $(SELECTORS.customLookName).val() || $(SELECTORS.customLookName).attr('data-product-name');
    let stayOnPage = $this.data('stay-on-page');

    if (lookId) {
        url = urlHelper.appendToUrl(url, { lookId: lookId });
    }

    if (customLookName) {
        url = urlHelper.appendToUrl(url, { customLookName: customLookName });
    }

    $(SELECTORS.customLookModalContent).spinner().start();
    $.ajax({
        url: url,
        dataType: 'json',
        method: 'GET',
        success: (data) => {
            $(SELECTORS.body).trigger('customLook:save', data);

            if (!stayOnPage) {
                window.location = data.redirectUrl;
            }
        }
    });
}

/**
 * Init events
 * @returns {void}
 */
function handleCustomLookNameInit() {
    $(SELECTORS.body).on('click', SELECTORS.duplicateLookBtn, handleDuplicateBtnClick);
    $(SELECTORS.body).on('click', SELECTORS.saveLookBtn, handleSaveLookBtnClick);
}

module.exports = {
    handleCustomLookNameInit: handleCustomLookNameInit,
};
